/**
 * « Réinitialiser » du panneau Filtrer (même rendu que le widget clearRefinements d'InstantSearch).
 *
 * Plages (prix, km, mensualité…) et finition vivent dans `rangeFiltersState` → configure.filters,
 * hors des refinements d'InstantSearch : le widget standard restait désactivé quand seuls ces
 * filtres étaient actifs et ne les retirait pas. Ici, le bouton est actif dès qu'un filtre
 * (facette, plage ou finition) est posé, et remet tout à l'état de base de la page.
 */
import { connectClearRefinements } from "instantsearch.js/es/connectors";
import {
    hasActiveRangeOrSpecificationFilter,
    resetRangeAndSpecificationFilters,
} from "@/services/algoliaRouting.blade";
import { syncSpecificationSearchUi } from "./specification-search";

let clearAll: (() => void) | null = null;

/** Retire tous les filtres du panneau (facettes, plages, finition). Sans effet avant le 1er rendu. */
export function clearAllMarketplaceFilters(): void {
    clearAll?.();
}

export function createClearAllFiltersWidget(containerSelector: string, label = "Réinitialiser") {
    const container = document.querySelector<HTMLElement>(containerSelector);
    if (!container) return null;

    const render = connectClearRefinements((renderState) => {
        const canRefine = renderState.canRefine || hasActiveRangeOrSpecificationFilter();
        clearAll = () => {
            if (renderState.canRefine) renderState.refine();
            resetRangeAndSpecificationFilters();
            syncSpecificationSearchUi();
        };

        const disabledClass = canRefine ? "" : " ais-ClearRefinements-button--disabled";
        container.innerHTML = `<div class="ais-ClearRefinements"><button data-attr="listing-filters-clear" class="ais-ClearRefinements-button clear-filters-button${disabledClass}"${canRefine ? "" : ' disabled=""'}>${label}</button></div>`;
        container.querySelector("button")?.addEventListener("click", () => clearAll?.());
    });

    return render({});
}
